import { get } from 'lodash';
export function useField(config) {
    var value = get(config.form.values, config.field);
    var error = get(config.form.errors, config.field);
    var touched = !!get(config.form.touched, config.field);
    var setValue = function (value, validate) {
        if (validate === void 0) { validate = true; }
        // This is to guarantee that set field is executed "after" all other react state changes have happened.
        setTimeout(function () {
            config.form.setFieldValue(config.field, value, validate);
        });
    };
    return {
        value: value,
        error: error,
        touched: touched,
        setValue: setValue
    };
}
